/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

import { overflowEllipsis } from 'src/styles/mixins';

export const DropdownItemLabelContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
});

export const DropdownItemAvatarContainer = styled.div({
  paddingRight: `${gridSize()}px`,
});

export const DropdownItemTextContainer = styled.div(overflowEllipsis());
